import * as React from 'react'

function SvgCatePpv(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        d="M21.95 5v14.012H2V5h19.95zm-.713 3.8H2.712v9.499h18.525V8.8zm-5.058 7.315v.713H7.866v-.713h8.313zm-4.185-4.465l1.503 1.8 2.655-1.319v3.534H7.835V12.13l2.596 1.318 1.563-1.799zm-4.413-.713a.475.475 0 110 .95.475.475 0 010-.95zm8.669 0a.475.475 0 110 .95.475.475 0 010-.95zm-4.275-.474a.475.475 0 110 .95.475.475 0 010-.95zM9.734 5.712H5.54l-.016.042-1.178 2.333h4.197l.026-.065 1.165-2.31zm4.988 0h-4.195l-.015.042-1.179 2.333h4.198l.025-.065 1.166-2.31zm4.75 0h-3.957l-.016.042-1.178 2.333h3.96l.025-.065 1.166-2.31zm1.765 0h-.972l-.016.042-1.178 2.333h2.166V5.712zm-16.49 0H2.712v2.375h.844l.025-.065 1.166-2.31z"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default SvgCatePpv
